<button class="btn btn-accent text-nowrap" (click)="logout()">
  {{ "authentication.logout.logout" | translate }}
</button>
